var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#28519E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8008 10.2734C11.8711 10.2734 11.9414 10.25 12.0117 10.25C13.2539 10.25 14.2617 11.2578 14.2617 12.5C14.2617 13.7422 13.2539 14.75 12.0117 14.75C10.7461 14.75 9.76172 13.7422 9.76172 12.5C9.76172 12.4531 9.76172 12.3828 9.76172 12.3125C9.97266 12.4297 10.2305 12.5 10.5117 12.5C11.332 12.5 12.0117 11.8438 12.0117 11C12.0117 10.7422 11.918 10.4844 11.8008 10.2734ZM16.5117 9.14844C17.6133 10.1562 18.3398 11.375 18.6914 12.2188C18.7617 12.4062 18.7617 12.6172 18.6914 12.8047C18.3398 13.625 17.6133 14.8438 16.5117 15.875C15.4102 16.9062 13.8867 17.75 12.0117 17.75C10.1133 17.75 8.58984 16.9062 7.48828 15.875C6.38672 14.8438 5.66016 13.625 5.30859 12.8047C5.23828 12.6172 5.23828 12.4062 5.30859 12.2188C5.66016 11.375 6.38672 10.1562 7.48828 9.14844C8.58984 8.11719 10.1133 7.25 12.0117 7.25C13.8867 7.25 15.4102 8.11719 16.5117 9.14844ZM12.0117 9.125C10.1367 9.125 8.63672 10.6484 8.63672 12.5C8.63672 14.375 10.1367 15.875 12.0117 15.875C13.8633 15.875 15.3867 14.375 15.3867 12.5C15.3867 10.6484 13.8633 9.125 12.0117 9.125Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewEyeIcon);
export default __webpack_public_path__ + "static/media/Preview-eye-icon.5be06b7605645be506485d4d57174208.svg";
export { ForwardRef as ReactComponent };